import _ from 'lodash';
import Emitter from '../services/emitter';
import Config from '../config';

export default class mElectronApi {

    constructor() {
    }

    static has(key) {
        return _.has(window, `window.MbApi.${key}`);
    }

    static openLink(e, url) {
        if (url) {
            e && e.preventDefault();
            if (this.has('openLink')) {
                window.MbApi.openLink(url);
            } else {
                window.open(url);
            }
        }
    }

    static select(opts) {
        if (this.has('file')) {
            return window.MbApi.file.select(opts);
        }
    }

    static read(file, opts) {
        if (this.has('file')) {
            return window.MbApi.file.open(file, opts);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static searchExistByJson(filePath, md5s, updateJson = false, updateFilePath) {
        if (this.has('file')) {
            return window.MbApi.file.searchExistByJson(filePath, md5s, updateJson, updateFilePath);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static searchExistInJson(filePath, md5) {
        if (this.has('file')) {
            return window.MbApi.file.searchExistInJson(filePath, md5);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static save(content, filePath, opts) {
        if (this.has('file')) {
            return window.MbApi.file.save(filePath, content, opts);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static uncompress(opts) {
        if (this.has('file')) {
            return window.MbApi.file.uncompress(opts);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static rename(filePath, newPath) {
        if (this.has('file')) {
            return window.MbApi.file.rename(filePath, newPath);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static write(filePath, data) {
        if (this.has('file')) {
            return window.MbApi.file.write(filePath, data);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static writeJson(opts, data) {
        if (this.has('file')) {
            return window.MbApi.file.writeJson(opts, data);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static stat(filePath) {
        if (this.has('file')) {
            return window.MbApi.file.stat(filePath);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static uploadToLocal(filePath, data, property) {
        if (this.has('file')) {
            return window.MbApi.file.uploadToLocal(filePath, data, property);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static removeFromLocal(filePath) {
        if (this.has('file')) {
            return window.MbApi.file.removeFromLocal(filePath);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static closeWindow() {
        if (this.has('closeWindow')) {
            window.MbApi.closeWindow();
        }
    }

    static restart() {
        if (this.has('restart')) {
            window.MbApi.restart();
        }
    }

    static locationPathname() {
        if (this.has('locationPathname')) {
            return `${location.origin}/${window.MbApi.locationPathname()}\\auth.html`.replace(/\\/g, '/');
        }
        return `${location.origin}/auth.html`;
    }

    static onReady() {
        if (this.has('onReady')) {
            window.MbApi.onReady();
        }
    }

    static downloadFile(downloadpath, savePath, id, cb) {
        if (this.has('file')) {
            return window.MbApi.file.downloadFile(downloadpath, savePath, id, cb);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }

    static saveDialog(opts) {
        if (this.has('file')) {
            return window.MbApi.file.saveDialog(opts);
        }
    }

    static copy(srcPath, descPath) {
        if (this.has('file')) {
            return window.MbApi.file.copy(srcPath, descPath);
        } else {
            return Promise.reject({ msg: 'not in electron' });
        }
    }
}

// 注入取消文件保存执行的事件
if (mElectronApi.has('file')) {
    Config.userSpriteBasepath = window.MbApi.file.userSpritePath;
    Config.userSpriteFilePath = Config.userSpriteBasepath;
    Config.userProjectBasepath = window.MbApi.file.userProjectPath;
    Config.userProjectFilePath = Config.userProjectBasepath;
    Config.userCoverImageBasepath = window.MbApi.file.userCoverImagePath;
    Config.userCoverImageFilePath = Config.userCoverImageBasepath;
    window.MbApi.file.addListeners(Emitter);
}

// 注册快捷键事件监听
if (mElectronApi.has('shortcutkey')) {
    window.MbApi.shortcutkey(Emitter);
}